import * as ScrollMagic from "scrollmagic";
import { TweenMax, TimelineMax } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import { deviceIsMobile } from '../utils/size-check';

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

if ($('.js-scroll-control').length) {
  $('.js-scroll-control').each(function () {
    const $scrollSection = $(this);
    const parentId = `#${$scrollSection.parents().attr('id')}`;
    /**
     * Update function for scroll magic
     */
    const updatePercetage = () => {
      timeline.progress();
    }
    // Settings
    const timeline = new TimelineMax({
      onUpdate: updatePercetage
    });
    const controller = new ScrollMagic.Controller();
    timeline.from(
      `${parentId} .js-scroll-image`, // Element
      3, // Duration
      {
        top: '25%',
        left: '25%',
        width: '50%',
        height: '50%'
      }
    )

    timeline.from(
      `${parentId} .js-scroll-text > *`, // Element
      3, // Duration
      {
        y: '100%',
        opacity: 0
      }
    )

    // Scroll Magic scene
    const scene = new ScrollMagic.Scene({
      triggerElement: `${parentId} .js-scroll-control`,
      triggerHook: 'onLeave',
      duration: '100%'
    })
      .setPin(`${parentId} .js-scroll-control`)
      .setTween(timeline)
        .addTo(controller)

    $(window).on('resize orientationchange', () => {
      controller.enabled(!deviceIsMobile())
      controller.enabled(!deviceIsMobile())
    })
  });
}
